import { Box, Theme, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";

interface StyleProps {
  color: string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  infoBox: {
    display: "flex",
    alignItems: "start",
    flexDirection: "column",
    width: "100%",
    padding: theme.spacing(1.5),
    gap: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 10,
  },
  disc: {
    width: 12,
    height: 12,
    borderRadius: "50%",
    backgroundColor: ({ color }) => color,
    display: "inline-block",
    marginRight: theme.spacing(1),
  },
}));

interface InfoBoxProps {
  value: number;
  unit?: string;
  color: string;
  label: string;
}

const InfoBox = (props: InfoBoxProps) => {
  const { value, unit, color, label } = props;
  const displayValue = Number.isFinite(value) ? value : 0;

  const s = useStyles({ color });
  return (
    <Box className={s.infoBox}>
      <Typography variant="h6">
        {displayValue} {unit}
      </Typography>
      <Box display="flex" flexDirection="row" alignItems="center">
        <Box className={s.disc} />
        <Typography variant="body2">{label}</Typography>
      </Box>
    </Box>
  );
};

export default InfoBox;
